import { Alarm, reportRequest } from './dataTypes';
import { httpRequest, BASE_URL } from './api-shared';
import moment from 'moment';

const ALARMS_URL = 'alarms';

export const getAlarmsApi = (request: reportRequest): Promise<Alarm[]> => {
    // Get formatted URL
    const url: string = formatReportURL(`${BASE_URL}/${ALARMS_URL}`, request);
    return httpRequest(url,
        'get'
    ).then(r => {
        if (r.success === true && r.data) {
            return r.data as Alarm[];
        } else {
            // alert("Error retreiving alarms, " + r.error!.message)
            throw (r.error);
        }
    });
};

export const ackAlarmApi = (alarm: Alarm) => {
    return httpRequest(`${BASE_URL}/${ALARMS_URL}/acknowledge`,
        'post', alarm
    ).then(r => {
        if (r.success === true && r.data) {
            return r.data as Alarm[];
        } else {
            alert("Error acknowledging alarm, " + r.error!.message)
            throw (alarm);
        }
    });
}

const formatReportURL = (rootUrl: string, data: reportRequest): string => {

    const start: string = `start=${data.startDate.toISOString()}`;
    // Bump the end day to 11:59 of the day so that all Alarms on the selected
    // day are included
    const end: string = data.endDate
        ? `&end=${moment(data.endDate).add(1, "day").startOf("day").toDate().toISOString()}` : '';
    const system: string = data.systemId ? `&sysId=${data.systemId}` : '';
    const org: string = data.org ? `&org=${data.org}` : '';

    return `${rootUrl}?${start}${end}${org}${system}`;
}